import Filter from 'components/ProjectList/Filter/Filter'
import LegacyProjectList from 'components/ProjectList/LegacyProjectList'
import Footer from 'components/shared/Footer/Footer'
import HtmlHead from 'components/shared/HtmlHead/HtmlHead'
import Loader from 'components/shared/Loader/Loader'
import NoMatch from 'components/shared/NoMatch/NoMatch'
import Pagination from 'components/shared/Pagination/Pagination'
import SiteHeader from 'components/shared/SiteHeader/SiteHeader'
import { getUrlParameter, tidyQueryString, updatePath } from 'helpers/Url'
import { withRouter } from 'helpers/withRouter'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import { withCookies } from 'react-cookie'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import { fetchProjects, searchProjects } from 'redux/actions/ProjectActions'

const ProjectListContainer = ({
  router: { navigate, location },
  i18n,
  t,
  dispatch,
  projects,
  cookies,
}) => {
  const [search, setSearch] = useState(null)
  const { currentLocale, entities, error, links, loading } = projects

  const searchOrFilter = useCallback(
    ({ searchParams, locale }) => {
      const urlSearchParams = getUrlParameter(searchParams, 'search')
      const sessionId = cookies.get('sessionProgress')
      if (urlSearchParams) {
        const pageParam = getUrlParameter(searchParams, 'page')
        dispatch(
          searchProjects({
            locale,
            searchTerm: urlSearchParams,
            page: pageParam,
            sessionId,
          })
        )
      } else {
        dispatch(fetchProjects(locale, searchParams))
      }
    },
    [dispatch, cookies]
  )

  useEffect(() => {
    if (currentLocale === i18n.language && location.search === search) {
      return
    }
    setSearch(location.search)
    searchOrFilter({ searchParams: location.search, locale: i18n.language })
  }, [i18n.language, currentLocale, location.search, search, searchOrFilter])

  const navigateToPageHandler = (url) => {
    updatePath(navigate, currentLocale, '/projects', tidyQueryString(url))
  }

  return (
    <div>
      <HtmlHead
        title={t('meta.projects.title')}
        description={t('meta.projects.description')}
      />
      <SiteHeader locale={currentLocale} />
      <Filter locale={currentLocale} location={location} navigate={navigate} />
      <Loader display={loading} />
      <NoMatch error={error} />
      {!loading && (
        <LegacyProjectList
          display={!loading && !error}
          locale={currentLocale}
          projects={Object.values(entities)}
        />
      )}
      <Pagination
        display={!loading && !error}
        links={links}
        onPageChange={navigateToPageHandler}
      />
      {!loading && (
        <Footer
          text="project.footer.feedback.homepage.text"
          userID="project-list-footer-user-id"
        />
      )}
    </div>
  )
}

ProjectListContainer.propTypes = {
  router: PropTypes.shape({
    navigate: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
  }).isRequired,
  cookies: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired,
  projects: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => {
  const { projects } = state
  return {
    projects,
  }
}

export { ProjectListContainer }
export default translate('translations')(
  connect(mapStateToProps)(withRouter(withCookies(ProjectListContainer)))
)
